import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import MainPageTemplate from "./templates/MainPageTemplate";
import Header from "../components/Header";
import Pins from "../components/Pins";
import ContentCreatorMain from "../components/ContentCreatorMain";
import IndexUserRatiosView from "../components/indexratiosview";
import IndexModesView from "../components/indexmodesview";
import IndexSeasonsView from "../components/indexseasonsview";
import IndexCollection from "../components/index_collections";
import IndexInventory from "../components/index_inventory";
import AwardsMain from "../components/AwardsMain";
import Character from "../components/Character";
import EquippedWeapons from "../components/EquippedWeapons";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import CustomContainer from "../components/container/CustomContainer";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";

import {
  USNNumber,
  mainPageData,
  pageHeaderData
} from "./sampleData/sampleData";
import {
  profileAPI,
  headerAPI,
  rankingAPI,
  _link,
  mainPageAnchors,
  getyouTubePlayList,
  gettwitchChannel,
  prefixURI
} from "../common/utilities";

import styles from "./MainPage.module.scss";
import { useTranslation } from "react-i18next";

const maxSectWidth = "xl";

function FooterLinks() {
  const { t } = useTranslation();

  return (
    <>
      <a href={_link["url_crossfire"]}>{t("Crossfire")}</a>
      {_link["cf_web_shop_url"] != null ? <a href={_link["cf_web_shop_url"]}>{t("Webstore")}</a> : null}
      <a href={_link["forum_url"]}>{t("Forums")}</a>
      <a href={_link["submit_ticket_url"]}>{t("Support")}</a>
    </>
  );
}

export default function MainPage(props) {
  const { t, i18n } = useTranslation();
  const { match, creator, devUSN, useSampleData } = props;

  const [pageData, setPageData] = useState(null);
  const [headerData, setHeaderData] = useState(null);
  const [bannerAvatarData, setBannerAvatarData] = useState(null);
  const [premiumLogged, setPremiumLogged] = useState(false);
  const [pageStatus, setPageStatus] = useState(true);

  //use defualt usn for now to prevent components that use it from breaking
  //on null usn - these components should be modified later to just be given
  //data instead of calling api based on usn themselves
  const [usn, setUSN] = useState(null);

  const myUSN = devUSN ? devUSN : match ? match.params.usn : null;

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [TIER_STAGE8_COUNT, setTIER_STAGE8_COUNT] = useState(null);

  let myTIER_STAGE8_COUNT = 0;

  //i'm thinking that header api should be called outside of
  //react router switching logic and passed into page compoents for use
  //- to allow for only 1 header API call when viewing new profile section
  // Similar to componentDidMount and componentDidUpdate:
  //
  // https://stackoverflow.com/questions/53120972/how-to-call-loading-function-with-react-useeffect-only-once
  useEffect(() => {

    if (useSampleData) {
      //dev only
      //use sample data
      setPageData(mainPageData);
      setHeaderData(pageHeaderData);
      setUSN(myUSN);
      setTIER_STAGE8_COUNT(null);
    } else {

      //api call to set data will be used
      axios.get(`${profileAPI}?usn=${myUSN}`).then(res => {
        if (res.data.p_o_ErrID === 1) setPageData(res.data);
      });

      axios.get(`${rankingAPI}`).then(res => {
        if(res.data.APIresult === '000' && res.data.ds_WEB_USER_ALLTIME_POG_Total && res.data.ds_WEB_USER_ALLTIME_POG_Total[0] && res.data.ds_WEB_USER_ALLTIME_POG_Total[0].glory_total){
          setTIER_STAGE8_COUNT(res.data.ds_WEB_USER_ALLTIME_POG_Total[0].glory_total);
          //console.log('TIER_STAGE8_COUNT data: ' + res.data.ds_WEB_USER_ALLTIME_POG_Total[0].glory_total);
        }else{
          setTIER_STAGE8_COUNT(0);
        }
      });

      axios.get(`${headerAPI}&usn=${myUSN}`).then(res => {
        if (res.data.p_o_ErrID === 1) {
          setHeaderData(res.data.dsProfileHeaderInfo[0]);
          let dsProfileHasRibbon = window._region === 'BR' ?
            res.data.dsProfileHasRibbon2 :
            res.data.dsProfileHasRibbon113;
          let dsProfileURL = window._region === 'BR' ?
            res.data.dsProfileURL2 :
            res.data.dsProfileURL113;

          if (dsProfileHasRibbon[0].HAS == 1 &&
            dsProfileURL.length > 0
          ) {
            setBannerAvatarData(dsProfileURL[0]);
          } else {
            setBannerAvatarData(false);
          }
        } else setPageStatus(false);
      });

      axios
        .get(`${profileAPI}?command=profilemanager&ribbon=${window._region === 'BR' ? 2 : 113}`, {
          withCredentials: true
        })
        .then(res => {
          if (
            res.data.APIresult == "000" &&
            res.data.p_o_ErrID == 1 &&
            (window._region === 'BR' ?
              res.data.dsProfileHasRibbon2[0].HAS == 1 :
              res.data.dsProfileHasRibbon113[0].HAS == 1
            ) &&
            res.data.usnfromcookie[0][""] == myUSN
          ) {
            setPremiumLogged(true);
          }
        });
      setUSN(myUSN);
    }

    scrollSpy.update();
  }, []);

  // we have data now, so we use these variables instead of 'creator'
  const dsProfileHasRibbon = window._region === 'BR' ? 'dsProfileHasRibbon18' : 'dsProfileHasRibbon112';
  const dsProfileURL = window._region === 'BR' ? 'dsProfileURL18' : 'dsProfileURL112';
  const youTubePlayList =
    pageData &&
    pageData[dsProfileHasRibbon] &&
    pageData[dsProfileHasRibbon][0] &&
    pageData[dsProfileHasRibbon][0].HAS &&
    "1" == pageData[dsProfileHasRibbon][0].HAS &&
    pageData[dsProfileURL] &&
    pageData[dsProfileURL][0] &&
    pageData[dsProfileURL][0].URL1_STATUS &&
    "1" == pageData[dsProfileURL][0].URL1_STATUS &&
    pageData[dsProfileURL][0].URL1_TEXT
      ? pageData[dsProfileURL][0].URL1_TEXT
      : null;

  const twitchChannel =
    pageData &&
    pageData[dsProfileHasRibbon] &&
    pageData[dsProfileHasRibbon][0] &&
    pageData[dsProfileHasRibbon][0].HAS &&
    "1" == pageData[dsProfileHasRibbon][0].HAS &&
    pageData[dsProfileURL] &&
    pageData[dsProfileURL][0] &&
    pageData[dsProfileURL][0].URL2_STATUS &&
    "1" == pageData[dsProfileURL][0].URL2_STATUS &&
    pageData[dsProfileURL][0].URL2_TEXT
      ? pageData[dsProfileURL][0].URL2_TEXT
      : null;

  return (
    <MainPageTemplate
      title={t(
        '{{ign}} - Crossfire Player Profile',
        { ign: headerData ? headerData.NICK : "" }
      )}
      headerData={headerData}
      bannerAvatarData={bannerAvatarData}
      premiumLogged={premiumLogged}
      usn={usn}
      creator={youTubePlayList || twitchChannel}
    >
      {!pageStatus ? <Redirect to={`${prefixURI}/error`} /> : null}
      <section
        id={mainPageAnchors.OVERVIEW.id}
        className={clsx(styles.overview, mobile && styles.mobile)}
      >
        <div
          className={clsx(
            styles.section_content_pins,
            mobile && styles.mobile
          )}
        >
          <Pins data={pageData != null ? pageData.dsProfilePINList : null} />
        </div>
        <CustomContainer
          maxWidth={maxSectWidth}
          classes={{
            root: clsx(styles.section_content_stats, mobile && styles.mobile)
          }}
        >
          <IndexUserRatiosView
            details={pageData != null ? pageData.dsProfileDetails[0] : null}
          />
        </CustomContainer>
      </section>
      {(youTubePlayList || twitchChannel) && (
        <section
          className={clsx(styles.section_content_creator)}
          id={mainPageAnchors.CONTENT_CREATOR.id}
        >
          <CustomContainer special maxWidth={maxSectWidth}>
            <div className={styles.content_creator_container}>
              <ContentCreatorMain
                youTubePlayList={youTubePlayList}
                twitchChannel={twitchChannel}
              />
            </div>
          </CustomContainer>
        </section>
      )}
      <section className={styles.stats}>
        <CustomContainer maxWidth={maxSectWidth}>
          <div
            id={mainPageAnchors.MODE_STATS.id}
            className={clsx(
              styles.mode_stats,
              styles.section_content_mode_stats,
              mobile && styles.mobile
            )}
          >
            <IndexModesView usn={usn} />
          </div>
          <div
            id={mainPageAnchors.RANKED_STATS.id}
            className={clsx(
              styles.ranked_stats,
              styles.section_content_ranked_stats,
              mobile && styles.mobile
            )}
          >
            <IndexSeasonsView
              userData={pageData && pageData.dsRankedStatsResult}
              totalData={pageData && TIER_STAGE8_COUNT}
            />
          </div>
          <div
            id={mainPageAnchors.AWARDS.id}
            className={clsx(
              styles.section_content_awards,
              mobile && styles.mobile
            )}
          >
            <AwardsMain
              ribbonsData={pageData != null ? pageData.dsRibbonResult : null}
              ribbonsCountData={
                pageData != null ? pageData.dsRibbonTotal[0] : null
              }
              dsProfileDetails={
                pageData != null && pageData.dsProfileDetails
                  ? pageData.dsProfileDetails[0]
                  : null
              }
              dsAchievementResult={
                pageData != null && pageData.dsAchievementResult
                  ? pageData.dsAchievementResult
                  : null
              }
              dsAchievementTotal={
                pageData != null && pageData.dsAchievementTotal
                  ? pageData.dsAchievementTotal
                  : null
              }
            />
          </div>
        </CustomContainer>
      </section>
      <section className={styles.character} id={mainPageAnchors.INVENTORY.id}>
        <CustomContainer special maxWidth={maxSectWidth}>
          <Character
            data={pageData != null ? pageData.dsProfileDetails[0] : null}
          />
        </CustomContainer>
        <p className={styles.character_disclaimer}>{t('Kills tracked from {{date}}', { date: window._region == 'BR' ? '4 de Fevereiro, 2020' : (window._region == 'NA' ? 'November 13, 2019' : '') })}</p>
      </section>
      <section
        className={clsx(
          styles.inventory,
          styles.inventory_content,
          mobile && styles.mobile
        )}
      >
        <Container
          classes={{ root: clsx(
            styles.no_left_right_padding,
            styles.section_content_equipped_weapons,
            mobile && styles.mobile
          )}}
          maxWidth={maxSectWidth}
        >
          <EquippedWeapons
            data={pageData != null ? pageData.dsProfileEquippedWeapons : null}
          />
        </Container>
        <CustomContainer maxWidth={maxSectWidth}>
          <IndexCollection
            counts={pageData && pageData.dsCollectionTotal}
            collections={pageData && pageData.dsCollectionResult}
          />
        </CustomContainer>
        <CustomContainer maxWidth={maxSectWidth}>
          <IndexInventory
            counts={pageData && pageData.dsInventoryTotal}
            userInventory={pageData && pageData.dsInventoryResult}
          />
        </CustomContainer>
      </section>
      <section className={styles.footer_links}>
        <FooterLinks />
      </section>
    </MainPageTemplate>
  );
}
